export function getLoginUrl() {
  return `/login`;
}
